import { all, fork } from 'redux-saga/effects';
import { actionWatcherGetVans } from './van/getAll';
import { actionWatcherGetHostVans } from './van/getHostVans';
import { actionWatcherGetFeatures } from './feature/getAll';
import { actionWatcherAddClient } from './order/addClient';
import { actionWatcherSignContract } from './contract/sign';
import { actionWatcherGetContract } from './contract/get';
import { actionWatcherGetVan } from './van/get';
import { actionWatcherGetLocations } from './location/getAll';
import { actionWatcherGetExtras } from './extra/getAll';
import { actionWatcherSetDriverLicense } from './driverLicense/addImages';
import { actionWatcherGetOneway } from './oneway/getAll';
import { actionWatcherAddDriver } from './driver/addDriver';
import { actionWatcherCheckVan } from './van/check';
import { actionWatcherCancelOrder } from './order/cancel';
import { actionWatcherGetSeasonPrice } from './seasonPrice/getAll';
import { actionWatcherGetSubPrice } from './subPrice/getAll';
import { actionWatcherGetSubLocations } from './subLocation/getAll';
import { actionWatcherGetClient } from './client/get';
import { actionWatcherSignIn } from './client/login';
import { actionWatcherExit } from './client/logout';
import { actionWatcherSignup } from './client/signup';
import { actionWatcherPayNow } from './client/pay';

export default function* rootSaga() {
  yield all([
    fork(actionWatcherGetVans),
    fork(actionWatcherGetHostVans),
    fork(actionWatcherGetFeatures),
    fork(actionWatcherGetExtras),
    fork(actionWatcherGetVan),
    fork(actionWatcherCheckVan),
    fork(actionWatcherAddClient),
    fork(actionWatcherGetContract),
    fork(actionWatcherGetLocations),
    fork(actionWatcherSignContract),
    fork(actionWatcherSetDriverLicense),
    fork(actionWatcherGetOneway),
    fork(actionWatcherAddDriver),
    fork(actionWatcherCancelOrder),
    fork(actionWatcherGetSeasonPrice),
    fork(actionWatcherGetSubPrice),
    fork(actionWatcherGetSubLocations),
    fork(actionWatcherGetClient),
    fork(actionWatcherSignIn),
    fork(actionWatcherExit),
    fork(actionWatcherSignup),
    fork(actionWatcherPayNow)
  ]);
}
